import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject, combineLatest, map, Observable } from 'rxjs';
import { HandleTimesheetsParams, TimesheetParsed } from '../../../models/timesheet';
import { SQL_TIME_FORMAT, UI_DATEPIPE_MMM_D_FORMAT } from '../../../parser.service';
import { T7eService } from '../../../t7e/t7e.service';
import { ContractParsed } from '../../../models/contract';
import { TimesheetService } from '../../timesheet.service';
import { AppService } from '../../../app.service';
import { TsCalcInfo } from '../../../models/ts-calc-info';
import { ProductionService } from '../../../prod/production.service';

@Component({
  selector: 'app-precalc-popup',
  templateUrl: './precalc-popup.component.html',
  styleUrls: ['./precalc-popup.component.scss']
})
export class PrecalcPopupComponent implements OnInit {

  @Input() days$: BehaviorSubject<PrecalcPopupData[]> = new BehaviorSubject<PrecalcPopupData[]>([]);
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();
  @Output() confirm: EventEmitter<void> = new EventEmitter<void>();

  ts_ForPage$?: Observable<Partial<TimesheetParsed>[]>

  onCancelled() {
    this.cancel.emit();
  }

  onConfirmed() {
    this.confirm.emit();
  }
  
  constructor(
    private prodSvc: ProductionService,
    private tsSvc: TimesheetService,
    private t7e: T7eService,
    private appSvc: AppService,
  ) { }

  DATE_FORMAT = UI_DATEPIPE_MMM_D_FORMAT
  TIME_FORMAT = SQL_TIME_FORMAT
  debug = this.appSvc.debug

  ngOnInit(): void {
    this.ts_ForPage$ = this.days$.pipe(
      map(days => days.map(day => ({

        ...this.tsSvc.parseTs({
          tsid: -1, // to avoid *ngIf="ts?.tsid"
          conid: day.contract?.conid,
          startdate: (day.saveParams._startdate ?? null) as string | null,
          enddate: (day.saveParams._enddate ?? null) as string | null,
          currency: day.contract?.f_currency || null,
          distandpark: day.saveParams._distandpark || null,
          park: day.saveParams._park || null,
          vignette: day.saveParams._vignette || null,
          dayoptions: Array.isArray(day.saveParams._dayoptions) ? day.saveParams._dayoptions : [],
          f_mealPenaltyHours: (day.saveParams._data ? JSON.parse(day.saveParams._data)?.mealPenaltyHours : null) as number | null,
          f_mealPenalty: (day.saveParams._data ? JSON.parse(day.saveParams._data)?.mealPenalty : null) as number | null,
          f_dailybasedrentalrate1: (day.saveParams._data ? JSON.parse(day.saveParams._data)?.dailybasedrentalrate1 : null) as number | null,
          f_dailybasedrentalrate2: (day.saveParams._data ? JSON.parse(day.saveParams._data)?.dailybasedrentalrate2 : null) as number | null,
          f_dailybasedrentalrate3: (day.saveParams._data ? JSON.parse(day.saveParams._data)?.dailybasedrentalrate3 : null) as number | null,
          f_dailybasedrentalrate4: (day.saveParams._data ? JSON.parse(day.saveParams._data)?.dailybasedrentalrate4 : null) as number | null,
          f_dailybasedrentalrate5: (day.saveParams._data ? JSON.parse(day.saveParams._data)?.dailybasedrentalrate5 : null) as number | null,
          f_dailybasedrentalrate6: (day.saveParams._data ? JSON.parse(day.saveParams._data)?.dailybasedrentalrate6 : null) as number | null,
          otherfee: day.saveParams._otherfee || null,
        }),

        // apply calcFees to ts for display
        calc_salary: day.calcsal ?? day.saveParams._salary ?? day.contract?.dailyrate ?? null,
        calc_overtimefee: day.calcot,
        calc_othours: day.calcothours,
        calc_tafee: day.calcta,
        calc_tahours: day.calctahours,

      })))
    )
  }


  t7eExplanationText = this.t7e.getTranslation('app-precalc-popup', 'explanation-text', 'innerText', null, null, 'Beküldés előtt ellenőrzd, hogy milyen díjak jóváhagyását kéred.')
}

export type PrecalcPopupData = Partial<TsCalcInfo>
  & {
  isLoading: boolean
  saveParams: HandleTimesheetsParams
  contract: ContractParsed | null
  }
